import { catchError, finalize } from 'rxjs/operators';
// RxJS
import { map } from 'rxjs/operators';
// CRUD
import { BaseDataSource } from './base.datasource';
import { BehaviorSubject, of } from 'rxjs';
import { BusinessService } from '../services/business.service';

export class MyBusinessDataSource extends BaseDataSource {
  loadCustomers(customerData: any) {
    throw new Error('Method not implemented.');
  }

	private loadingSubject = new BehaviorSubject<boolean>(false);
	private isPreloadTextViewedSubject = new BehaviorSubject<boolean>(true);

	public loading$ = this.loadingSubject.asObservable();
	public isPreloadTextViewed$ = this.isPreloadTextViewedSubject.asObservable();

	public noRecords = new BehaviorSubject<boolean>(false);
	public noRecords$ = this.noRecords.asObservable();

	public dasboardRecord = new BehaviorSubject<any>({});
	constructor(private mybusinesssService: BusinessService) {
		super();
	}
	loadMybusiness(mybusinessFilterList) {
		this.loadingSubject.next(true);
		this.entitySubject.next([]);
	 this.isPreloadTextViewedSubject.next(true);

		this.mybusinesssService.getDashboard(mybusinessFilterList)
			.pipe(
				map(
					mybusiness => {
						// console.log(mybusiness);
						if (
							!mybusiness.data || 
							!mybusiness.data.referralBusinessList || 
							!mybusiness.data.referralBusinessList.results || 
							mybusiness.data.referralBusinessList.results.length === 0
						  ) {
							this.noRecords.next(true);
							this.paginatorTotalSubject.next(
							  mybusiness && mybusiness.data && mybusiness.data.referralBusinessList
								? mybusiness.data.referralBusinessList.totalRecords
								: 0
							);
							this.entitySubject.next([]);
						  } else {
							this.paginatorTotalSubject.next(mybusiness.data.referralBusinessList.totalRecords);
							this.entitySubject.next(mybusiness.data.referralBusinessList.results);
							this.dasboardRecord.next(mybusiness.data.referralBusinessCount);
							this.noRecords.next(false);
						  }
						  
					}
				),
				catchError(() => of([])),
				finalize(() => {
					this.loadingSubject.next(false);
					this.isPreloadTextViewedSubject.next(false);
				})
			)
			.subscribe();
	}
}
